export default __webpack_public_path__ + "static/media/a023-03.e5ac0e24.png";